/* eslint-disable import/prefer-default-export */

export const PRODUCT_APPLICATION_METHODS = [
  { key: 'None', value: 'None' },
  { key: 'Aerial', value: 'Aerial' },
  { key: 'Air Blast', value: 'Air Blast' },
  { key: 'Chemigation', value: 'Chemigation' },
  { key: 'Fertigation', value: 'Fertigation' },
  { key: 'Fumigation', value: 'Fumigation' },
  { key: 'Ground', value: 'Ground' },
  { key: 'Ground - Banded', value: 'Ground - Banded' },
  { key: 'Ground - Broadcast', value: 'Ground - Broadcast' },
  { key: 'Ground - Hooded', value: 'Ground - Hooded' },
  { key: 'Ground - In Furrow', value: 'Ground - In Furrow' },
  { key: 'Ground - Incorporated', value: 'Ground - Incorporated' },
  { key: 'Ground - Seed Treatment', value: 'Ground - Seed Treatment' },
  { key: 'Ground - Spot', value: 'Ground - Spot' },
  { key: 'Ground - Variable Rate', value: 'Ground - Variable Rate' },
  { key: 'Ground - Wipe', value: 'Ground - Wipe' },
  { key: 'Ground Application', value: 'Ground Application' },
  { key: 'Planting', value: 'Planting' },
  { key: 'Re-Planting', value: 'Re-Planting' },
  { key: 'Sidedress / Topdress', value: 'Sidedress' },
  { key: 'Storage', value: 'Storage' },
  { key: 'Topdress', value: 'Topdress' },
  { key: 'Tree Injection', value: 'Tree Injection' },
  { key: 'Water Run', value: 'Water Run' }
];
